import React from 'react';
import Col from 'antd/lib/col';
import List from 'antd/lib/list';
import Row from 'antd/lib/row';
import { useRouter } from 'next/router';
import APP_ROUTES from 'src/common/appRoutes';
import { handleBreakline } from 'src/common/utils';
import { handleData } from 'src/components/Heatmap/history/HistoryItem';
import { IinforProject, IresourceProject } from 'src/interface/IHeatmapState';
import { Label as L, Text as T } from 'src/styled/Component';
import { Flex } from 'src/styled/Layout';

interface Props {
  historyList: IresourceProject[];
  projects: IinforProject[];
}

const HistoryItem: React.FC<Props> = (props: Props) => {
  const router = useRouter();
  const { historyList } = props;
  const data = handleData(historyList);

  const Title = ({ data }: any) => {
    return (
      <Row align={'middle'} className={'records-history'}>
        <Col span={24}>
          <Flex full between itemCenter>
            <T.ProjectTitle color={data.color}>{`[${data.id}] ${data.project}`}</T.ProjectTitle>
            <L.ColorLabel width={75} height={30} color={data.color}>
              {data.hour} hours
            </L.ColorLabel>
          </Flex>
        </Col>
      </Row>
    );
  };

  return (
    <>
      <List
        style={{
          height: 'auto',
          overflowY: 'auto'
        }}
        itemLayout={'horizontal'}
        dataSource={data.slice(0, 4)}
        renderItem={(item) => (
          <List.Item style={{ border: 'none', padding: '6px 0' }}>
            <List.Item.Meta
              avatar={null}
              title={<Title data={item}></Title>}
              description={
                <div
                  style={{ paddingLeft: 20 }}
                  dangerouslySetInnerHTML={{
                    __html: handleBreakline(item.activity)
                  }}
                />
              }
            />
          </List.Item>
        )}
      />
      <Flex flexend>
        <T.ActionText fz={12} onClick={() => router.push(APP_ROUTES.HEATMAP)}>
          View more
        </T.ActionText>
      </Flex>
    </>
  );
};

export default HistoryItem;
